export const CREATORS_DASHBOARD_TAB_ORDER = ['dashboards', 'brand-logos'] as const;

export type CreatorsDashboardTabKey = (typeof CREATORS_DASHBOARD_TAB_ORDER)[number];

export function isCreatorsDashboardTabKey(value: string | null | undefined): value is CreatorsDashboardTabKey {
  return !!value && (CREATORS_DASHBOARD_TAB_ORDER as readonly string[]).includes(value);
}

/** Creator dashboards is the default; a known ?tab= wins. */
export function resolveInitialCreatorsDashboardTab(
  searchParams: Pick<URLSearchParams, 'get'>,
): CreatorsDashboardTabKey {
  const tab = searchParams.get('tab');
  return isCreatorsDashboardTabKey(tab) ? tab : 'dashboards';
}
